/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Kind_DealInputs */

const cs_pipelines_kind_deal = /** @type {(inputs: Pipelines_Kind_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchody`)
};

const en_pipelines_kind_deal = /** @type {(inputs: Pipelines_Kind_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal work`)
};

/**
* | output |
* | --- |
* | "Deal work" |
*
* @param {Pipelines_Kind_DealInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_kind_deal = /** @type {((inputs?: Pipelines_Kind_DealInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Kind_DealInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_kind_deal(inputs)
	return cs_pipelines_kind_deal(inputs)
});